<nav class="navbar sticky-top justify-content-end">
    <div class="row" *ngIf="!isMobile">
        <!-- <div class="col-md-auto col-xs-12">
                <input type="search" class="form-control" placeholder="Search Contact List" [value]="storedSearchValue"
                    (keyup)="tableControls.search($event.target.value);"
                    (search)="tableControls.search($event.target.value);">
            </div> -->
        <div class="col-auto">
            <button class="btn btn-outline-primary ms-2 mt-md-0 mt-1" (click)="getHistory()" ngbTooltip="refresh">
                <fa-icon [icon]="faRefresh"></fa-icon>
            </button>
        </div>
        <div class="col-auto">
            <button class="btn btn-outline-primary ms-2 mt-md-0 mt-1" (click)="openFilterModal()" ngbTooltip="Filter">
              {{this.startDate}} to {{this.endDate}}&nbsp;<fa-icon [icon]="faFilter"></fa-icon>
            </button>
        </div>
        <div class="col-auto">
            <div ngbDropdown class="d-inline-block" display="dynamic" placement="bottom-right">
                <button id="INVOICES_DROPDOWN" type="button" class="btn btn-primary ms-2 mt-md-0 mt-1"
                    ngbDropdownToggle>Options</button>
                <div ngbDropdownMenu aria-labelledby="INVOICES_DROPDOWN">
                    <button ngbDropdownItem (click)="export()">
                        <fa-icon class="button-icon-left" [icon]="faFileDownload"></fa-icon>
                        <span>Export</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row-container" *ngIf="isMobile">
      <div class="top-row">
        <div class="col-auto">
          <button class="btn btn-outline-primary" (click)="getHistory()" ngbTooltip="refresh">
            <fa-icon [icon]="faRefresh"></fa-icon>
          </button>
        </div>
        <div class="col-auto">
          <div ngbDropdown class="d-inline-block" display="dynamic" placement="bottom-right">
            <button id="INVOICES_DROPDOWN" type="button" class="btn btn-primary"
                ngbDropdownToggle>Options</button>
            <div ngbDropdownMenu aria-labelledby="INVOICES_DROPDOWN">
                <button ngbDropdownItem (click)="export()">
                    <fa-icon class="button-icon-left" [icon]="faFileDownload"></fa-icon>
                    <span>Export</span>
                </button>
            </div>
         </div>
        </div>
      </div>
      <div class="bottom-row">
        <button class="btn btn-outline-primary" (click)="openFilterModal()" ngbTooltip="Filter">
          {{this.startDate}} to {{this.endDate}}&nbsp;<fa-icon [icon]="faFilter"></fa-icon>
        </button>
      </div>
    </div>
</nav>
<div class="table-responsive mt-3">
    <table *ngIf="!isMobile" class="table">
        <thead>
            <tr>
                <!-- Invoice # -->
                <!-- <th (click)="tableControls.sort('c.contact_first_name');">
                        First Name
                        <fa-icon *ngIf="tableControls.isSortedBy('c.contact_first_name')"
                            [icon]="(tableControls.isSortedASC() ? faSortDown : faSortUp)" class="sortButton"></fa-icon>
                    </th> -->
                <th>
                    Call ID and Date
                </th>
                <th>
                    From
                </th>
                <th>
                    To
                </th>
                <th>
                    Status
                </th>
                <th>
                    Direction
                </th>
                <th>
                    Duration
                </th>
                <!-- <th>
                    Cost
                </th> -->
                <th>Recordings</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let call of calls">
                <td>
                    <span> {{ call.date_created | date: 'short' }}</span>
                    <br />
                    <span class="text-muted" style="font-size: 0.7em">{{ call.sid }}</span>
                </td>
                <td>
                    <div *ngIf="call.contactFrom; else numberOnly">
                        <span> {{ call.contactFrom }}</span>
                        <br />
                        <span class="text-muted" style="font-size: 0.7em">{{ call.from }}</span>
                    </div>
                    <ng-template #numberOnly>
                        {{call.from}}
                    </ng-template>
                </td>
                <td>
                    <div *ngIf="call.contactTo; else numberOnlyTo">
                        <span> {{ call.contactTo }}</span>
                        <br />
                        <span class="text-muted" style="font-size: 0.7em">{{ call.to }}</span>
                    </div>
                    <ng-template #numberOnlyTo>
                        {{call.to}}
                    </ng-template>
                </td>
                <td>{{call.status}}</td>
                <td>{{call.direction}}</td>
                <td>{{formatSeconds(call.duration)}}</td>
                <!-- <td>
                    {{ call.price | currency : 'USD' : 'symbol' : '1.3-4' }}
                </td> -->
                <td>
                    <div *ngIf="call.recordingUrl; else noRecording">
                        <audio controls>
                            <!-- <source src="horse.ogg" type="audio/ogg"> -->
                            <source [src]="call.recordingUrl + '.mp3'" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <ng-template #noRecording>
                        <span>No Recording Available</span>
                    </ng-template>
                </td>
                <td>
                    <button type="button" class="btn btn-primary mt-md-0 mt-1" (click)="callAgain(call.to)">
                        <fa-icon class="button-icon-center color-green" [icon]="faPhone"></fa-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="scrollable" *ngIf="isMobile">
      <ul class="list-group">
          <li *ngFor="let call of calls" class="list-group-item list-group-item-action">
              <div class="d-flex list-group-container">
                  <div>
                      <strong class="first-info">Call ID: {{call?.sid}}</strong>
                      <small class="text-muted" *ngIf="call?.date_created">Date: {{call?.date_created | date: 'short'}}</small>
                      <div><strong>From:</strong> {{call?.from}}</div>
                      <div><strong>To:</strong> {{call?.contactTo ? call?.contactTo: call?.to }}</div>
                      <div><strong>Status: </strong>{{call?.status}}</div>
                      <div><strong>Direction:</strong> {{call?.direction}}</div>
                      <div><strong>Duration:</strong> {{formatSeconds(call?.duration)}}</div>
                      <!-- <div><strong>Cost:</strong> {{call?.price | currency : 'USD' : 'symbol' : '1.3-4'}}</div> -->
                      <div><strong>Recordings:</strong>
                        <div *ngIf="call.recordingUrl; else noRecording">
                          <audio controls>
                              <!-- <source src="horse.ogg" type="audio/ogg"> -->
                              <source [src]="call.recordingUrl + '.mp3'" type="audio/mpeg">
                              Your browser does not support the audio element.
                          </audio>
                        </div>
                        <ng-template #noRecording>
                            <span>No Recording Available</span>
                        </ng-template>
                      </div>
                      <div class="list-button">
                        <button type="button" class="btn btn-primary mt-md-0 mt-1" (click)="callAgain(call?.to)">
                          <fa-icon class="button-icon-center color-green" [icon]="faPhone"></fa-icon>
                        </button>
                      </div>
                  </div>
              </div>
          </li>
          <li *ngIf="calls?.length == 0" class="list-group-item">No Calls</li>
      </ul>
    </div>
</div>
<div class="row table-controls">
    <div *ngIf="tableControls.isNotDefault() && !isMobile" class="col-auto mt-3 me-2 me-md-0">
      <button type="button" class="btn btn-outline-danger" (click)="tableControls.resetTableConfiguration();">
        <fa-icon class="button-icon-left" [icon]="faRotateLeft"></fa-icon>
        <span>Reset</span>
      </button>
    </div>
    <div class="col mt-3">
      <div ngbDropdown placement="top-left" class="d-inline-block">
        <button class="btn btn-outline-primary" ngbDropdownToggle>Page Size: {{tableControls.getLimit()}}</button>
        <div ngbDropdownMenu class="page-size-dropdown" *ngIf="!isMobile">
          <button ngbDropdownItem (click)="tableControls.setLimit(5);">5</button>
          <button ngbDropdownItem (click)="tableControls.setLimit(50);">50</button>
          <button ngbDropdownItem (click)="tableControls.setLimit(100);">100</button>
        </div>
        <div ngbDropdownMenu class="page-size-dropdown" *ngIf="isMobile">
          <button ngbDropdownItem (click)="tableControls.setLimit(5);">5</button>
          <button ngbDropdownItem (click)="tableControls.setLimit(10);">10</button>
          <button ngbDropdownItem (click)="tableControls.setLimit(20);">20</button>
        </div>
      </div>
    </div>

    <div class="col my-3">
        <ngb-pagination class="d-flex justify-content-end" *ngIf="totalCalls > 0" [page]="tableControls.getCurrentPage()"
            [pageSize]="tableControls.getLimit()" [collectionSize]="totalCalls" [boundaryLinks]="true" [maxSize]="(isMobile) ? 1 : 10"
            [ellipses]="true" [rotate]="true" (pageChange)="getHistory($event)"></ngb-pagination>
    </div>
</div>
